export default {
    getDetailedUserReportsTotalDuration: state => {
        let totalDuration = 0

        state.detailedReports.forEach(report => {
            totalDuration += report.duration
        })

        return totalDuration
    }
}